import { gql, useMutation } from "@apollo/client";
import { useCallback } from "react";
import { getSiteGraphqlUrl } from "@hooks/use-site-context/utils";

const RESET_USER_PASSWORD = gql`
  mutation ResetUserPassword($key: String!, $login: String!, $password: String!) {
    resetUserPassword(input: { key: $key, login: $login, password: $password }) {
      clientMutationId
      user {
        id
      }
    }
  }
`;

export const useResetPassword = () => {
  const [doResetPassword, { loading }] = useMutation(RESET_USER_PASSWORD, {
    context: { uri: getSiteGraphqlUrl() },
  });

  const resetPassword = useCallback(
    async (key: string, login: string, password: string) => {
      try {
        const result = await doResetPassword({ variables: { key, login, password } });
        return result.data?.resetUserPassword ?? null;
      } catch {
        return null;
      }
    },
    [doResetPassword]
  );

  return { resetPassword, loading };
};
